import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/photo.png';
import _imports_1 from '@/assets/images/model-poster-img.png';
import _imports_2 from '@/assets/images/loading.png';
const _withScopeId = n => (_pushScopeId("data-v-25ea61a3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "illustrate"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "margin": "0 auto"
  }
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 2,
  class: "el-upload__text"
};
const _hoisted_5 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_6 = {
  class: "tip"
};
const _hoisted_7 = {
  class: "main-content"
};
const _hoisted_8 = {
  class: "introduce-list"
};
const _hoisted_9 = {
  class: "introduce-item"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_11 = {
  class: "info rightTextShow"
};
const _hoisted_12 = {
  class: "title"
};
const _hoisted_13 = {
  class: "titleSecond"
};
const _hoisted_14 = {
  class: "titleThird"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.sciencedirect.com/science/article/abs/pii/S0957417424000010",
  style: {
    "background-image": "none",
    "background": "no-repeat center right",
    "padding-right": "0px",
    "font-size": "18px",
    "text-decoration": "none",
    "font-weight": "bold",
    "color": "#006FFF"
  }
}, "Expert Systems with Applications", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.sciencedirect.com/science/article/pii/S1566253523001203?via%3Dihub",
  style: {
    "background-image": "none",
    "background": "no-repeat center right",
    "padding-right": "0px",
    "font-size": "18px",
    "text-decoration": "none",
    "font-weight": "bold",
    "color": "#006FFF"
  }
}, "Information Fusion", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://link.springer.com/article/10.1007/s00530-023-01178-8",
  style: {
    "background-image": "none",
    "background": "no-repeat center right",
    "padding-right": "0px",
    "font-size": "18px",
    "text-decoration": "none",
    "font-weight": "bold",
    "color": "#006FFF"
  }
}, "Multimedia Systems", -1));
const _hoisted_18 = {
  style: {
    "text-align": "right"
  }
};
const _hoisted_19 = {
  class: "image-info-warp"
};
const _hoisted_20 = {
  class: "image-box"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  key: 0,
  class: "image-info"
};
const _hoisted_23 = {
  class: "antiqueInfo"
};
const _hoisted_24 = {
  key: 1,
  class: "image-info error"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "uploadError"
}, "上传失败,请重新上传!", -1));
const _hoisted_26 = [_hoisted_25];
const _hoisted_27 = {
  class: "retrieve-result"
};
const _hoisted_28 = {
  key: 0,
  class: "loading-placeholder"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "loading-img",
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_30 = {
  class: "minutes"
};
const _hoisted_31 = {
  class: "minutes"
};
const _hoisted_32 = {
  key: 1,
  class: "result-list"
};
const _hoisted_33 = {
  class: "result-img"
};
const _hoisted_34 = ["src"];
const _hoisted_35 = ["onClick"];
import PosterSearchDescription from '@/components/PosterSearchDescription';
import { ref, computed, watch } from 'vue';
import { genFileId, ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/css';
import axios from 'axios';
import i18n from '@/language';
import { useGlobalStore } from '@/store';
// import { arrayBufferToBase64 } from '@/utils/index.js'

export default {
  __name: 'Poster',
  setup(__props) {
    // import Header from '@/components/Header'
    // import PageFooter from '@/components/PageFooter'
    const isRetrieval = ref(true);
    const backgroundColor = ref('');
    const noOpaque = ref(true);
    const uploadPopover = ref();
    const uploadRef = ref();
    const uploadInputUrl = ref(); // 输入的图片url
    const imgPreviewUrl = ref(''); // 预览图url
    const currentFile = ref(null); // 当前上传的文件
    const isStartUpload = ref(false); // 是否已点击检索抄袭
    const imgSize = ref(''); // 上传的图片的尺寸
    const uploadType = ref(''); // 上传的是文件还是提交url
    const loading = ref(false); // 是否计算中
    const uploadError = ref(false); // 请求失败显示
    const textInput = ref('');
    const resultList = ref([]);
    const globalStore = useGlobalStore();
    const resultObjs = ref({});

    // 监听语言
    watch(() => globalStore.languageValue, (newValue, oldValue) => {
      if (isStartUpload.value === true) {
        submitUpload();
      }
    });

    // 监视 i18n.global.locale.value 的变化
    watch(() => i18n.global.locale.value, (newVal, oldVal) => {
      language.value = newVal;
    });
    function downImg(item) {
      // 这里是获取到的图片base64编码,这里只是个例子哈，要自行编码图片替换这里才能测试看到效果
      const imgUrl = item;
      // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
      if (window.navigator.msSaveOrOpenBlob) {
        const bstr = atob(imgUrl.split(',')[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        const blob = new Blob([u8arr]);
        window.navigator.msSaveOrOpenBlob(blob, 'chart-download' + '.' + 'png');
      } else {
        // 这里就按照chrome等新版浏览器来处理
        const a = document.createElement('a');
        a.href = imgUrl;
        a.setAttribute('download', 'chart-download');
        a.click();
      }
    }

    // 海报生成按钮
    const handleRetrieval = () => {
      isRetrieval.value = !isRetrieval.value;
      backgroundColor.value = '#612617';
      noOpaque.value = !noOpaque.value;
    };
    const goBack = () => {
      isRetrieval.value = !isRetrieval.value;
      backgroundColor.value = 'rgba(0, 0, 0,.2)';
      noOpaque.value = !noOpaque.value;
    };

    // 预计时间
    const progressTime = computed(() => {
      return timing.value >= 60 ? 1 : 1;
    });
    const language = ref(i18n.global.locale.value);

    // 拖拽上传组件触发
    function uploadChange(uploadFile, uploadFiles) {
      var _uploadFile$raw;
      if (uploadFile.status === 'ready' && !(uploadFile !== null && uploadFile !== void 0 && (_uploadFile$raw = uploadFile.raw) !== null && _uploadFile$raw !== void 0 && _uploadFile$raw.oldFile)) {
        uploadType.value = 'file';
        currentFile.value = uploadFile.raw;
        // 获取图片的尺寸信息
        const url = window.URL || window.webkitURL;
        const img = new Image();
        img.src = url.createObjectURL(uploadFile.raw);
        img.onload = () => {
          imgSize.value = `${img.width} x ${img.height}px`;
        };
        imgPreviewUrl.value = url.createObjectURL(uploadFile.raw);
        submitUpload();
        uploadPopover.value.hide();
      }
    }

    // url输入框改变触发
    function uploadUrlChange() {
      uploadType.value = 'url';
    }

    // 上传弹窗内右下角上传文件按钮触发
    function uploadChange1(uploadFile, uploadFiles) {
      uploadRef.value.clearFiles();
      const file = uploadFile.raw;
      file.uid = genFileId();
      uploadRef.value.handleStart(file);
    }
    function handleExceed(files) {
      uploadRef.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      uploadRef.value.handleStart(file);
    }

    // let returnImgUrl // 后台把url解析成图片并返回的url

    // 手动提交上传
    function submitUpload() {
      (uploadType.value === 'file' || uploadType.value === 'url') && setTimeout(() => {
        isStartUpload.value = true;
        targetClasses.value = [];
        resultList.value = [];
      }, 200);
      if (uploadType.value === 'file') {
        // 上传的是图片文件时
        uploadRef.value.submit();
        loading.value = true;
        uploadError.value = false;
        startTiming();
      } else if (uploadType.value === 'url') {
        imgPreviewUrl.value = uploadInputUrl.value;
        loading.value = true;
        uploadError.value = false;
        uploadUrl();
      }
    }

    // 上传组件上传文件成功回调
    function uploadSuccess(res) {
      if (res.status === 200 && res.data.status === 200) {
        loading.value = false;
        uploadError.value = false;
        processResult(res.data);
        timing.value = 0;
        clearInterval(time);
        uploadRef.value.clearFiles();
        const file = currentFile.value;
        file.oldFile = true;
        file.uid = genFileId();
        uploadRef.value.handleStart(file);
      }
      if (res.status === 200 && res.data.status === 400) {
        loading.value = false;
        clearInterval(time);
        uploadError.value = true;
      }
    }
    const CancelToken = axios.CancelToken;
    let source = CancelToken.source();

    // 上传后台返回的url检索图片
    function uploadUrl() {
      // print(local)
      startTiming();
      getBase64Image(uploadInputUrl.value).then(base64 => {
        const data = {
          key_num: language.value === 'zh' ? 1 : 0,
          name: 'imgName',
          posterImg: base64,
          getLocation: textInput.value
        };
        axios.post('/poster-api/', data, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(res => {
          loading.value = false;
          timing.value = 0;
          clearInterval(time);
          processResult(res.data);
        }).then(err => {
          console.error(err);
        });
      });
    }
    const targetClasses = ref([]);
    function processResult(data) {
      resultList.value = data.newPosterImg.slice(0, 4);
      const {
        location,
        caption,
        headline,
        time
      } = data;
      resultObjs.value = {
        location,
        caption,
        headline,
        time
      };
    }

    // 开始计时
    let time = null;
    const timing = ref(0); // 计算时间
    function startTiming() {
      time && clearInterval(time);
      timing.value = 0;
      time = setInterval(() => {
        timing.value += 1;
      }, 1000);
    }
    function handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;
      if (!items || items.length === 0) {
        ElMessage.error('当前浏览器不支持本地');
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile();
          break;
        }
      }
      if (!file) {
        ElMessage.error('粘贴内容非图片');
        return;
      }
      // 此时file就是我们的剪切板中的图片对象
      // 如果需要预览，可以执行下面代码
      const reader = new FileReader();
      reader.readAsDataURL(file);
      uploadRef.value.clearFiles();
      file.uid = genFileId();
      uploadRef.value.handleStart(file);
    }

    // 刷新按钮
    function refresh() {
      if (uploadType.value === 'file') {
        uploadRef.value.abort();
        uploadRef.value.clearFiles();
        const file = currentFile.value;
        file.uid = genFileId();
        uploadRef.value.handleStart(file);
        submitUpload();
      } else {
        loading.value = true;
        source.cancel();
        source = CancelToken.source();
        uploadUrl();
      }
    }
    function filetoBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader(); // 实例化文件读取对象
        reader.readAsDataURL(file); // 将文件读取为 DataURL,也就是base64编码
        reader.onload = e => {
          // 文件读取成功完成时触发
          const dataURL = e.target.result; // 获得文件读取成功后的DataURL,也就是base64编码
          resolve(dataURL);
        };
      });
    }
    function getBase64Image(src) {
      return new Promise(resolve => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = src;
        img.onload = function () {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, img.width, img.height);
          const ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase();
          const dataURL = canvas.toDataURL('image/' + ext);
          resolve(dataURL);
        };
      });
    }
    function httpRequest(options) {
      // print(local)
      return new Promise((resolve, reject) => {
        filetoBase64(options.file).then(base64 => {
          const data = {
            key_num: language.value === 'zh' ? 1 : 0,
            name: 'imgName',
            posterImg: base64,
            getLocation: textInput.value
          };
          axios.post('/poster-api/', data, {
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          });
        });
      });
    }
    const triggerPopover = () => {
      document.getElementById('hidden__button').click();
    };
    function backTop() {
      document.documentElement.scrollTop = 0;
    }
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_popover = _resolveComponent("el-popover");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", null, [_createElementVNode("div", {
        class: _normalizeClass(["upload-bg", {
          'small': isStartUpload.value
        }])
      }, [_withDirectives(_createElementVNode("h2", null, _toDisplayString(_ctx.$t('poster.posterTitle')), 513), [[_vShow, !isStartUpload.value]]), _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('poster.posterSubtitle')), 1), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
        class: _normalizeClass(["reference-button", _unref(i18n).global.locale.value === 'en' ? 'inputWidth' : '']),
        size: "large",
        onChange: uploadUrlChange,
        modelValue: uploadInputUrl.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => uploadInputUrl.value = $event),
        placeholder: _ctx.$t('protection.placeholderUrl')
      }, {
        suffix: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "el-input__icon",
          onClick: triggerPopover,
          style: {
            "color": "#612617"
          }
        })]),
        _: 1
      }, 8, ["modelValue", "placeholder", "class"]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        size: "large",
        onClick: submitUpload,
        class: _normalizeClass(_unref(i18n).global.locale.value === 'en' ? 'buttonWidth' : '')
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('poster.generateBtn')), 1)]),
        _: 1
      }, 8, ["class"])), [[_directive_loading, loading.value]]), _createVNode(_component_el_popover, {
        ref_key: "uploadPopover",
        ref: uploadPopover,
        "popper-class": "uploadPopper",
        placement: "bottom-end",
        width: "3.44rem",
        "show-arrow": false,
        trigger: "click"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_button, {
          id: "hidden__button",
          style: {
            "width": "0px",
            "margin": "0px",
            "border": "0px"
          }
        })]),
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          ref_key: "uploadRef",
          ref: uploadRef,
          class: "upload-box",
          drag: "",
          action: "/poster-api/",
          "show-file-list": false,
          limit: 1,
          name: "posterImg",
          accept: "image/*",
          "http-request": httpRequest,
          "on-exceed": handleExceed,
          "auto-upload": false,
          "on-change": uploadChange,
          "on-success": uploadSuccess
        }, {
          default: _withCtx(() => [imgPreviewUrl.value ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: imgPreviewUrl.value,
            alt: "",
            style: {
              "height": "251px",
              "object-fit": "contain"
            },
            onPaste: handlePaste
          }, null, 40, _hoisted_3)) : _createCommentVNode("", true), !imgPreviewUrl.value ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "upload-img",
            src: _imports_0,
            alt: "",
            onPaste: handlePaste
          }, null, 32)) : _createCommentVNode("", true), !imgPreviewUrl.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('protection.drag')), 1)) : _createCommentVNode("", true)]),
          _: 1
        }, 512), _createVNode(_component_el_input, {
          class: "locationInput",
          modelValue: textInput.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => textInput.value = $event),
          placeholder: _ctx.$t('protection.localtionInputtext')
        }, null, 8, ["modelValue", "placeholder"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_upload, {
          limit: 1,
          "show-file-list": false,
          accept: "image/*",
          "auto-upload": false,
          "on-change": uploadChange1,
          "on-exceed": handleExceed
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "upload-button",
            size: "large",
            style: {
              "color": "#ffffff"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('protection.localUpload')), 1)]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      }, 512)]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("span", {
        onClick: handleRetrieval
      }, _toDisplayString(_ctx.$t('protection.use')), 513), [[_vShow, !isStartUpload.value]])])], 2), _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_Transition, {
        appear: "",
        mode: "out-in",
        name: "animate__animated animate__bounce",
        "enter-active-class": "animate__animated animate__InLeft",
        "leave-active-class": "animate__animated animate__fadeOut"
      }, {
        default: _withCtx(() => [_hoisted_10]),
        _: 1
      }), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('poster.automatically')), 1), _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('poster.automaticallySubtitle')), 1), _createElementVNode("p", _hoisted_14, [_createTextVNode(_toDisplayString(_ctx.$t('poster.automaticallyDescription')) + " ", 1), _hoisted_15, _createTextVNode(" " + _toDisplayString(_ctx.$t('poster.automaticallyDescription3')) + " ", 1), _hoisted_16, _createTextVNode(" " + _toDisplayString(_ctx.$t('poster.automaticallyDescription1')) + " ", 1), _hoisted_17, _createTextVNode(" " + _toDisplayString(_ctx.$t('poster.automaticallyDescription2')), 1)])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("a", {
        href: "javascript:void(0)",
        onClick: backTop
      }, _toDisplayString(_ctx.$t('home.tryNow')), 1)])])])], 512), [[_vShow, !isStartUpload.value]]), _withDirectives(_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("img", {
        src: imgPreviewUrl.value,
        alt: ""
      }, null, 8, _hoisted_21)]), !uploadError.value ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('poster.information')), 1), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(_ctx.$t('poster.location')) + "： ", 1), _createElementVNode("span", null, _toDisplayString(resultObjs.value.location), 1)]), _createElementVNode("div", null, [_createTextVNode(_toDisplayString(_ctx.$t('poster.caption')) + "： ", 1), _createElementVNode("span", null, _toDisplayString(resultObjs.value.headline), 1)]), _createElementVNode("div", null, [_createTextVNode(_toDisplayString(_ctx.$t('poster.description')) + "： ", 1), _createElementVNode("span", null, _toDisplayString(resultObjs.value.caption), 1)]), _createElementVNode("div", null, [_createTextVNode(_toDisplayString(_ctx.$t('poster.date')) + "： ", 1), _createElementVNode("span", null, _toDisplayString(resultObjs.value.time), 1)])])), [[_directive_loading, loading.value]])])) : _createCommentVNode("", true), uploadError.value ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26)) : _createCommentVNode("", true)], 512), [[_vShow, isStartUpload.value]]), _withDirectives(_createElementVNode("div", _hoisted_27, [_withDirectives(_createElementVNode("h3", null, _toDisplayString(_ctx.$t('poster.result')), 513), [[_vShow, resultList.value.length]]), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_hoisted_29, _createElementVNode("p", null, [_createTextVNode(_toDisplayString(_ctx.$t('protection.loading')) + "......" + _toDisplayString(_ctx.$t('protection.please')), 1), _createElementVNode("span", _hoisted_30, _toDisplayString(progressTime.value), 1), _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('protection.minutes')), 1)]), _withDirectives(_createElementVNode("div", {
        class: "wait"
      }, _toDisplayString(_ctx.$t('protection.long')), 513), [[_vShow, timing.value >= 180]]), _withDirectives(_createVNode(_component_el_button, {
        size: "large",
        style: {
          "color": "#ffffff",
          "background-color": "#612617"
        },
        onClick: refresh
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('noFind.agian')), 1)]),
        _: 1
      }, 512), [[_vShow, timing.value >= 180]])])) : (_openBlock(), _createElementBlock("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "poster-result",
          key: index
        }, [_createElementVNode("img", {
          src: item,
          alt: ""
        }, null, 8, _hoisted_34), _createElementVNode("div", {
          class: "poster-dow",
          onClick: $event => downImg(item)
        }, _toDisplayString(_ctx.$t('poster.posterDownload')), 9, _hoisted_35)]);
      }), 128))])]))], 512), [[_vShow, isStartUpload.value]])])], 512), [[_vShow, isRetrieval.value]]), _withDirectives(_createVNode(_unref(PosterSearchDescription), {
        onGoBack: goBack
      }, null, 512), [[_vShow, !isRetrieval.value]])], 64);
    };
  }
};